/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects'
import getEducationalHealthActions, {
    getEducationalHealthTypes,
} from '../../../redux/donneesSocioEconomique/getEducationalHealth'
import { Get } from '../../../serveur/axios'

function* getEducationalHealthSagas({ response }) {
    const { governorate, year, yearSecondary } = response

    let url = 'editique/socio_economic/institutions_educatives_sante?'

    if (governorate) {
        url = `${url}&gouvernorat=${governorate}`
    }
    if (year) {
        url = `${url}&year=${year}`
    }
    if (yearSecondary) {
        url = `${url}&yearSecondary=${yearSecondary}`
    }

    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getEducationalHealthActions.getEducationalHealthSuccess(res)
                ),
            ])
        } else {
            yield put(
                getEducationalHealthActions.getEducationalHealthFailure(res)
            )
        }
    } catch (error) {
        yield put(
            getEducationalHealthActions.getEducationalHealthFailure(error)
        )
    }
}

export function* getEducationalHealthSaga() {
    yield takeLatest(
        getEducationalHealthTypes.GET_EDUCATIONAL_HEALTH_REQUEST,
        getEducationalHealthSagas
    )
}
